module.exports = __webpack_public_path__ + "img/logo_sm.f4fc657d.png";